import { computed, onMounted, ref, onBeforeUnmount } from '@vue/composition-api';
import uploadTaskManager from '@/renderer/scripts/utils/upload/index';
import downloadTaskManager from '@/renderer/scripts/utils/download/index';
import { FileInfo } from '@/renderer/scripts/utils/upload/types';
import { TaskManagerList } from '@/renderer/scripts/utils/TaskManager/types';
import { DownloadFileInfo } from '@/renderer/scripts/utils/download/types';
export default function handleTransmissionNum() {
  const uploadNum = ref(0);
  const downloadNum = ref(0);
  const methods = {
    handleUploadNum(params: TaskManagerList<FileInfo>) {
      uploadNum.value = params.running.length + params.waiting.length;
    },
    handleDownloadNum(params: TaskManagerList<DownloadFileInfo>) {
      downloadNum.value = params.running.length + params.waiting.length;
    },
  };
  const transmissionNum = computed(() => uploadNum.value + downloadNum.value);
  onMounted(() => {
    uploadTaskManager.on('list-update', methods.handleUploadNum);
    downloadTaskManager.on('list-update', methods.handleDownloadNum);
  });
  onBeforeUnmount(() => {
    uploadTaskManager.off('list-update', methods.handleUploadNum);
    downloadTaskManager.off('list-update', methods.handleDownloadNum);
  });
  return {
    transmissionNum,
  };
}
